<template>
  <div class="no-data">
    <img src="../../assets/images/nodata.svg" alt="">
    <p>暂无数据</p>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.no-data{
  text-align: center;
  img{
    width: 80px;
    height: 80px;
  }
}
</style>
